import useTracker from '@/hooks/useTracker';
import { AUTO_SETOR_DELETE, AUTO_SETOR_UPDATE } from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventClickUpdateMFAutoOrder = () => {
    trackEvent(AUTO_SETOR_UPDATE);
  };

  const eventClickDeleteMFAutoOrder = (props) => {
    trackEvent(AUTO_SETOR_DELETE, props);
  };

  return {
    eventClickUpdateMFAutoOrder,
    eventClickDeleteMFAutoOrder,
  };
};

export default useEventTracker;
